module.exports = __webpack_public_path__ + "img/texacone.4ac69800.png";